import React, { useState } from 'react';

// 더미 데이터
const dummyStats = {
    averageRating: 4.8,
    totalReviews: 127,
    ratingDistribution: {
        5: 98,
        4: 22,
        3: 5,
        2: 1,
        1: 1
    },
    trustScore: 95,
    responseRate: 98,
    averageResponseTime: '2시간'
};

const dummyReviews = [
    {
        id: 1,
        studentName: '김학생',
        studentImage: 'https://via.placeholder.com/50',
        rating: 5,
        date: '2025-01-10',
        content: '정말 좋은 코치님이세요! 연기 실력이 많이 늘었어요. 친절하고 자세하게 설명해주셔서 감사합니다.',
        product: '연기 기초 마스터 클래스',
        helpful: 12
    },
    {
        id: 2,
        studentName: '박연습',
        studentImage: 'https://via.placeholder.com/50',
        rating: 5,
        date: '2025-01-08',
        content: '댄스 클래스가 너무 재미있었어요. 다음에도 또 들을 예정입니다!',
        product: 'K-pop 댄스 비디오 강의',
        helpful: 8
    },
    {
        id: 3,
        studentName: '이성장',
        studentImage: 'https://via.placeholder.com/50',
        rating: 4,
        date: '2025-01-05',
        content: '보컬 트레이닝이 도움이 많이 되었습니다. 다만 시간이 조금 짧았던 것 같아요.',
        product: '보컬 트레이닝 패키지',
        helpful: 5
    },
    {
        id: 4,
        studentName: '최지망',
        studentImage: 'https://via.placeholder.com/50',
        rating: 5,
        date: '2025-01-03',
        content: '오디션 준비에 정말 도움이 많이 되었어요. 감사합니다!',
        product: '오디션 준비 특강',
        helpful: 15
    }
];

const KoachProfileReview = () => {
    const [stats] = useState(dummyStats);
    const [reviews] = useState(dummyReviews);
    const [filter, setFilter] = useState('all');

    const filteredReviews = filter === 'all' 
        ? reviews 
        : reviews.filter(r => r.rating === parseInt(filter));

    const renderStars = (rating: number) => {
        return Array.from({ length: 5 }, (_, i) => (
            <span key={i} className={i < rating ? 'text-yellow-400' : 'text-gray-300'}>
                ★
            </span>
        ));
    };

    return (
        <div className="min-h-screen bg-gray-50 pt-20 pb-4 px-4">
            <div className="max-w-6xl mx-auto">
                <h1 className="text-2xl font-bold text-gray-900 mb-6">평가 & 신뢰</h1>

                {/* 통계 카드 */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                    <div className="bg-white rounded-lg shadow-sm p-6 text-center">
                        <p className="text-sm text-gray-600 mb-2">평균 평점</p>
                        <p className="text-3xl font-bold text-[#CF3688] mb-1">
                            {stats.averageRating}
                        </p>
                        <div className="flex justify-center gap-1">
                            {renderStars(Math.round(stats.averageRating))}
                        </div>
                        <p className="text-xs text-gray-500 mt-1">
                            총 {stats.totalReviews}개 리뷰
                        </p>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm p-6 text-center">
                        <p className="text-sm text-gray-600 mb-2">신뢰 점수</p>
                        <p className="text-3xl font-bold text-gray-900">
                            {stats.trustScore}
                        </p>
                        <p className="text-xs text-gray-500 mt-1">점</p>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm p-6 text-center">
                        <p className="text-sm text-gray-600 mb-2">응답률</p>
                        <p className="text-3xl font-bold text-gray-900">
                            {stats.responseRate}%
                        </p>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm p-6 text-center">
                        <p className="text-sm text-gray-600 mb-2">평균 응답 시간</p>
                        <p className="text-3xl font-bold text-gray-900">
                            {stats.averageResponseTime}
                        </p>
                    </div>
                </div>

                {/* 평점 분포 */}
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">평점 분포</h2>
                    <div className="space-y-3">
                        {[5, 4, 3, 2, 1].map((rating) => {
                            const count = stats.ratingDistribution[rating as keyof typeof stats.ratingDistribution];
                            const percentage = (count / stats.totalReviews) * 100;
                            return (
                                <div key={rating} className="flex items-center gap-4">
                                    <div className="flex items-center gap-1 w-20">
                                        <span className="text-sm font-medium text-gray-700">{rating}</span>
                                        <span className="text-yellow-400">★</span>
                                    </div>
                                    <div className="flex-1 bg-gray-200 rounded-full h-4 relative">
                                        <div 
                                            className="bg-[#CF3688] h-4 rounded-full"
                                            style={{ width: `${percentage}%` }}
                                        />
                                    </div>
                                    <span className="text-sm text-gray-600 w-12 text-right">
                                        {count}개
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* 리뷰 필터 */}
                <div className="flex gap-2 mb-6">
                    <button
                        onClick={() => setFilter('all')}
                        className={`px-4 py-2 rounded-lg transition-colors ${
                            filter === 'all' 
                                ? 'bg-[#CF3688] text-white' 
                                : 'bg-white text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                        전체
                    </button>
                    {[5, 4, 3, 2, 1].map((rating) => (
                        <button
                            key={rating}
                            onClick={() => setFilter(rating.toString())}
                            className={`px-4 py-2 rounded-lg transition-colors ${
                                filter === rating.toString() 
                                    ? 'bg-[#CF3688] text-white' 
                                    : 'bg-white text-gray-700 hover:bg-gray-100'
                            }`}
                        >
                            {rating}점
                        </button>
                    ))}
                </div>

                {/* 리뷰 목록 */}
                <div className="space-y-4">
                    {filteredReviews.map((review) => (
                        <div key={review.id} className="bg-white rounded-lg shadow-sm p-6">
                            <div className="flex items-start space-x-4">
                                <img 
                                    src={review.studentImage} 
                                    alt={review.studentName}
                                    className="w-12 h-12 rounded-full object-cover"
                                />
                                <div className="flex-1">
                                    <div className="flex items-center justify-between mb-2">
                                        <div>
                                            <h3 className="font-semibold text-gray-900">{review.studentName}</h3>
                                            <p className="text-sm text-gray-500">{review.date}</p>
                                        </div>
                                        <div className="flex items-center gap-1">
                                            {renderStars(review.rating)}
                                        </div>
                                    </div>
                                    <p className="text-gray-700 mb-2">{review.content}</p>
                                    <div className="flex items-center justify-between">
                                        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                                            {review.product}
                                        </span>
                                        <div className="flex items-center gap-4 text-sm text-gray-500">
                                            <span>👍 도움됨 {review.helpful}</span>
                                            <button className="text-[#CF3688] hover:text-[#B52E74]">
                                                답변하기
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default KoachProfileReview;

